import {gql, useMutation, useReactiveVar, useQuery} from "@apollo/client";
import {
  CreateTestingFacilityForm,
  Modal,
  CreateTestingFacilityInitialValues,
  CreateTestingFacilityFormSchema,
} from "components";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { wrapClick } from "utils";
import {currentUserVar} from "../../../apollo/cache/auth";
import {useEffect} from "react";
import {removeTypename} from "../../../utils/object";


const GET_METER_CONTRACTOR = gql`
  query GetMeterContractor(
    $id: ID!
  ) {
    meterContractor: getMeterContractor(
      id: $id
    ) {
      testingFacility {
        name
        address
        ghanaPostAddress
        contactPerson {
          fullName
          emailAddress
          phoneNumber
        }
      }
      
    }
  }
`;

const CREATE_MATERIAL_STORE = gql`
  mutation CreateTestingFacility(
    $id: ID!
    $testingFacility: MeterContactorTestingFacilityInput!
  ) {
    updateMeterContractorTestingFacility(
      id: $id
      testingFacility: $testingFacility
    ) {
      _id
    }
  }
`;

export default function CreateMeterContractorTestingFacilityContainer({
 open,
 setOpen,
 refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {

  const currentUser = useReactiveVar(currentUserVar);

  const { data, loading, } = useQuery(
    GET_METER_CONTRACTOR,
    {
      variables: { id: currentUser.contractor?._id },
      notifyOnNetworkStatusChange: false,
    }
  );

  const [updateTestingFacilities, { loading: updateLoading }] = useMutation(
    CREATE_MATERIAL_STORE
  );

  const form = useFormik({
    initialValues: CreateTestingFacilityInitialValues,
    validationSchema: CreateTestingFacilityFormSchema,
    onSubmit: async (values) => {
      await updateTestingFacilities({
        variables: {
          id: currentUser?.contractor?._id,
          testingFacility: values
        },
      }).then(({ data }) => {
        if (data.updateMeterContractorTestingFacility?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Facility Created Successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not create Facility",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  useEffect(() => {
    let testingFacility = data?.meterContractor?.testingFacility;
    if(testingFacility){
      testingFacility = removeTypename(testingFacility);
      form.setValues(
        (old) => ({
          ...old,
          ...testingFacility,
          ...(testingFacility?.district?._id ? {
            district: testingFacility?.district?._id
          }: {})
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Update Your Meter Testing Facility"
      description="Provide the details to update your meter testing facility"
      size="4xl"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={updateLoading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {updateLoading ? "Updating..." : "Update"}
          </button>
        </>
      )}
    >
      <CreateTestingFacilityForm form={form} />
    </Modal>
  );
}
